module.exports = __webpack_public_path__ + "img/1.9bc32096.png";